import { useCallback } from 'react';

import { useSurveyGate } from '../contexts/SurveyGateContext';
import { trackerRunningService } from '../services/trackerService';
import { createSurveyFlowCancelledError, getSurveyRequirementFromError } from '../utils/surveyGate';

const useTrackerStartWithSurvey = () => {
  const { requestSurveyCompletion } = useSurveyGate();

  return useCallback(
    async function startTrackerWithSurvey(startPayload) {
      try {
        return await trackerRunningService(startPayload);
      } catch (error) {
        const requiredSurvey = getSurveyRequirementFromError(error);

        if (!requiredSurvey) {
          throw error;
        }

        const didCompleteSurvey = await requestSurveyCompletion(requiredSurvey);

        if (!didCompleteSurvey) {
          throw createSurveyFlowCancelledError();
        }

        return startTrackerWithSurvey(startPayload);
      }
    },
    [requestSurveyCompletion]
  );
};

export default useTrackerStartWithSurvey;
